import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {withRouter, Redirect} from 'react-router';
import {generateRoutePath} from 'epic-common/src/route';
import Header from './Header';
import BackgroundVideo from 'epic-react-common/src/components/BackgroundVideo';
import queryString from 'query-string';
import LoginActions from '../../actions/LoginActions';
import classNames from 'classnames';

class SignUpPage extends React.Component {
    static propTypes = {
        content: PropTypes.object,
        isLoggedIn: PropTypes.bool,
        status: PropTypes.object,
        history: PropTypes.object,
        title: PropTypes.string,
        mobile: PropTypes.bool,
        tablet: PropTypes.bool,
        location: PropTypes.object,
        android: PropTypes.bool,
        isSamsung: PropTypes.bool,
        downloadActive: PropTypes.bool
    };

    componentDidUpdate(prevProps) {
        if (this.props.status !== prevProps.status) {
            const {status, android, history, location} = this.props;
            if (status && status.registered) {
                const query = queryString.parse(location.search) || {};
                if (android) {
                    history.push(generateRoutePath(`/mobile/android/confirm?${queryString.stringify(query)}`));
                } else {
                    history.push(generateRoutePath(`/mobile/confirm?${queryString.stringify(query)}`));
                }
            }
        }
    }

    getReturnPath = () => {
        const {android, location} = this.props;
        const query = queryString.parse(location.search) || {};
        if (android) {
            return `/mobile/android/device-select?${queryString.stringify(query)}`;
        }
        return `/mobile/device-select?${queryString.stringify(query)}`;
    };

    requestLogin = () => {
        LoginActions.requestLogin({
            redirectUrl: this.getReturnPath()
        });
    };

    render() {
        const {content, isLoggedIn, title, mobile, tablet, android, isSamsung, downloadActive} = this.props;

        const query = queryString.parse(this.props.location.search) || {};
        const androidDeviceSelect = `${generateRoutePath('/mobile/android/device-select')}?${queryString.stringify(query)}`;
        const iosDeviceSelect = `${generateRoutePath('/mobile/device-select')}?${queryString.stringify(query)}`;
        const deviceSelect = android ? androidDeviceSelect : iosDeviceSelect;

        //redirect samsung users to get started flows //
        if (isSamsung && android && downloadActive) {
            return <Redirect to={generateRoutePath(`/mobile/android/download?${queryString.stringify(query)}`)} />;
        }
        const signUpClass = classNames('sign-up-page', {android});
        return (
            <div className={signUpClass}>
                <div className="header-wrapper">
                    <div className="container-fluid content-wrapper">
                        <div className="head">
                            <div className="content text-center">
                                <Header android title={title} />
                                <div className="main-content" dangerouslySetInnerHTML={{__html: content.title}} />
                                <div className="btn-container text-center">
                                    {!isLoggedIn ? (
                                        <button id="fnMobile-signUp-btn" onClick={this.requestLogin} className="btn btn-primary height">
                                            <span>{content.cta}</span>
                                            <span className="small">{content.emailReminder}</span>
                                        </button>
                                    ) : (
                                        <Link id="fnMobile-signUp-btn-signedIn" to={deviceSelect} className="btn btn-primary height">
                                            <span>{content.cta}</span>
                                            <span className="small">{content.emailReminder}</span>
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="space-man" />
                    </div>
                </div>
                <div className="container-fluid white-bk">
                    <div className="container text-section text-center">
                        <div className="row">
                            <div className="col-xs-12">
                                <div className="requirements" dangerouslySetInnerHTML={{__html: content.note}} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12">
                                <div className="embed-responsive embed-responsive-16by9 media-container">
                                    <BackgroundVideo
                                        background={content.video}
                                        play={false}
                                        noOverlay
                                        playsInline={mobile || tablet}
                                        loop
                                        enableRatioHelper={false}
                                        mobile={mobile}
                                        tablet={tablet}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12">
                                <div dangerouslySetInnerHTML={{__html: content.description}} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(SignUpPage);
